"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ManageTimeField = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _AccessTime = _interopRequireDefault(require("@material-ui/icons/AccessTime"));
var _ManageTextField2 = require("./ManageTextField");
var _DateTime = require("../../utils/DateTime");
var _PopupMenu = require("../PopupMenu");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, e, r, o) { var p = _get(_getPrototypeOf(1 & o ? t.prototype : t), e, r); return 2 & o ? function (t) { return p.apply(r, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
  * Provides an inline ManageTextField component with time picker popup menu and optional "Never" button that can be used to
  * set times.  The ManageTextField component behavior is unchanged, but picking a time from the popup menu will set the time string on the 
  * text field. Pressing the Never button will set the "Never" string.  Both actions will
  * commit the change (causing the date to be parsed, and if successful, to make a callback to onFieldChange.
  * 
  * The default time format is a clock time but the "relativeTime" prop can change this
  * 
  * 
  * The caller must supply props (same as ManageTextField):
  * 
  * label:  the label for the field (String)
  * json:   a key to identify the field, passed back to the focus lost callback.  If null, field is read only
  * onFieldChange: the callback function called when focus is lost, called with two parameters: the json key prop, and the validated time string, null for never
  * onParseError: a callback called when the time that is entered fails parsing (invalid time), called with two parameters (the label and error string)
  * 
  * The caller can supply:
  * 
  * relativeTime: true if the time is a relative amount of time (days, hours, minutes) - default is false - interpret as clock time
  * ref: a React reference set on the ManageTextField component for directly controlling its text.
  * 
  * The caller may supply the optional props:
  * 
  * isReadOnly: set as read only. If not supplied, it is not read only
  * editable:      if the user has permissions to edit the field (otherwise read only), default true
  * hasNever: true to show the Never button
  * initialValue: initial text, if not supplied, use empty text.  
  * neverText: text for the Never button, default "Never"
  * clockColor: the color of the time picker icon, black if not specified
  * twelveHour: if supplied and true, time is not converted to 24-hour time. Note: the user must be sure to call DateUtils.parseTimeString to get a JsonTimeString
  *             ignored when relativeTime is true
  */

var ClockTimes = function () {
  var timesArray = [];
  var minutes = 0;
  while (minutes < 60 * 24) {
    var hr = Math.floor(minutes / 60);
    var min = minutes - hr * 60;
    if (min < 10) min = "0" + min;
    var ampm = hr >= 12 ? "PM" : "AM";
    if (hr === 0) hr = "12";
    if (hr > 12) hr = hr - 12;
    var value = hr + ":" + min + " " + ampm;
    var component = /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        fontSize: 12
      }
    }, value);
    timesArray.push({
      component: component,
      value: value
    });
    minutes += 30;
  }
  return timesArray;
}();
var RelativeTimes = function () {
  var times = [{
    label: "1 hour",
    value: "1h"
  }, {
    label: "2 hours",
    value: "2h"
  }, {
    label: "3 hours",
    value: "3h"
  }, {
    label: "6 hours",
    value: "6h"
  }, {
    label: "12 hours",
    value: "12h"
  }, {
    label: "24 hours",
    value: "24h"
  }, {
    label: "2 days",
    value: "2d"
  }, {
    label: "3 days",
    value: "3d"
  }, {
    label: "5 days",
    value: "5d"
  }, {
    label: "1 week",
    value: "7d"
  }, {
    label: "2 weeks",
    value: "14d"
  }, {
    label: "3 weeks",
    value: "21d"
  }, {
    label: "30 days",
    value: "30d"
  }, {
    label: "60 days",
    value: "60d"
  }, {
    label: "90 days",
    value: "90d"
  }, {
    label: "180 days",
    value: "180d"
  }, {
    label: "1 year",
    value: "365d"
  }, {
    label: "2 years",
    value: "730d"
  }];
  var timesArray = times.map(function (time) {
    return {
      component: /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          fontSize: 12
        }
      }, time.label),
      value: time.value
    };
  });
  return timesArray;
}();
var ManageTimeField = exports.ManageTimeField = /*#__PURE__*/function (_ManageTextField) {
  function ManageTimeField(props) {
    var _this;
    _classCallCheck(this, ManageTimeField);
    _this = _callSuper(this, ManageTimeField, [props]);
    _defineProperty(_this, "_neverText", "Never");
    _defineProperty(_this, "_isRelative", false);
    _defineProperty(_this, "_clockColor", void 0);
    _defineProperty(_this, "_timePicked", function (time) {
      _this.change(time, true);
      _this.autoAcceptIfNeeded();
    });
    _defineProperty(_this, "_buttonPressed", function () {
      _this.change(_this._neverText, true);
      _this.autoAcceptIfNeeded();
    });
    _defineProperty(_this, "_timeMenuItems", function () {
      var disabled = _this.props.isReadOnly || !_this._isEditable;
      if (disabled) return [];
      var menuItems = [];
      var choices = _this._isRelative ? RelativeTimes : ClockTimes;
      choices.forEach(function (time) {
        menuItems.push({
          label: time.component,
          selectCallback: function selectCallback() {
            return _this._timePicked(time.value);
          }
        });
      });
      return menuItems;
    });
    if (props.neverText) _this._neverText = props.neverText;
    if (props.relativeTime) _this._isRelative = props.relativeTime;
    _this._style = {}; //remove any styling on text field

    _this._clockColor = props.clockColor ? props.clockColor : 'black';
    return _this;
  }

  //Override!
  _inherits(ManageTimeField, _ManageTextField);
  return _createClass(ManageTimeField, [{
    key: "commit",
    value: function commit(text) {
      var _this2 = this;
      if (this.props.hasNever && text === this._neverText) {
        _superPropGet(ManageTimeField, "commit", this, 3)([null]); //set the time to "null"
      } else {
        //parse time

        var time;
        try {
          if (this._isRelative) time = _DateTime.DateUtils.relativeTimeFormat(_DateTime.DateUtils.parseRelativeTimeString(text)); //parse and reformat
          else {
            time = _DateTime.DateUtils.parseTimeString(text); //set the text to the standard time string, 24 hour time
            if (this.props.twelveHour)
              // back to 12 hour
              time = _DateTime.DateUtils.toFriendlyTimeString(time);
          }
          this.change(time);
        } catch (error) {
          setTimeout(function () {
            return _this2.props.onParseError(_this2.props.label, error.toString());
          }, 1);
          this.reset(); //reset the text field to the original text
          return;
        }
        _superPropGet(ManageTimeField, "commit", this, 3)([time]);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var disabled = this.props.isReadOnly || !this._isEditable;
      var tooltipText = this._isRelative ? "Enter a time as DDd HHh MMm (days, hours, minutes)" : "Enter a time as HH:mm (24 hour) or hh:mm pm (12 hour)";

      //Render the popup menu and buttons surrounded along with the (super's) text field
      return /*#__PURE__*/_react["default"].createElement("span", {
        style: _objectSpread(_objectSpread({}, this.props.style), {}, {
          width: '100%',
          display: 'flex',
          alignItems: 'center'
        })
      }, /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
        title: tooltipText
      }, /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          width: '100%',
          display: 'flex'
        }
      }, _superPropGet(ManageTimeField, "render", this, 3)([]))), /*#__PURE__*/_react["default"].createElement(_PopupMenu.PopupMenu, {
        menuIcon: /*#__PURE__*/_react["default"].createElement(_AccessTime["default"], {
          style: {
            fontSize: 28,
            color: disabled ? 'lightGray' : this._clockColor
          }
        }),
        menuItems: this._timeMenuItems(),
        menuIconStyle: {
          marginLeft: 2,
          paddingLeft: 10,
          marginRight: -2
        },
        menuTooltipText: "Time Selector"
      }), this.props.hasNever ? /*#__PURE__*/_react["default"].createElement(_core.Button, {
        variant: "outlined",
        disabled: disabled,
        onClick: this._buttonPressed,
        style: {
          marginLeft: 0,
          height: 40
        }
      }, this._neverText) : null);
    }
  }]);
}(_ManageTextField2.ManageTextField);